module.exports = __webpack_public_path__ + "img/logo-white.516c2e4b.svg";